import { render, staticRenderFns } from "./page-data.vue?vue&type=template&id=6c309750&scoped=true&"
import script from "./page-data.vue?vue&type=script&lang=js&"
export * from "./page-data.vue?vue&type=script&lang=js&"
import style0 from "./page-data.vue?vue&type=style&index=0&id=6c309750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c309750",
  null
  
)

export default component.exports